import { FormManager } from 'react-form-state-manager';

import { CouponType } from '__generated__/graphql';
import UI from '../../../../common/UI';
import useCurrencyInput from '../../../../common/useCurrencyInput';
import useNumberInput from '../../../../common/useNumberInput';

interface CouponData {
  type: CouponType;
}

interface CouponValueInputProps<TCouponData extends CouponData> {
  form: FormManager<TCouponData>;
}

const CouponValueInput = <TCouponData extends CouponData>({ form }: CouponValueInputProps<TCouponData>) => {
  const currencyInput = useCurrencyInput();
  const numberInput = useNumberInput();

  if (form.values.type === CouponType.absolute) {
    return (
      <UI.CurrencyInput
        {...form.text('value', { inputHandler: {
          parse: currencyInput.parse,
          format: currencyInput.value,
        } })}
        id="CouponValue"
      />
    );
  }

  return (
    <UI.InputWrapper>
      <UI.Input
        id="CouponValue"
        {...form.text('value', { inputHandler: numberInput({ min: 0, max: 100, decimals: 0 }) })}
        placeholder="0"
      />
      <span>%</span>
    </UI.InputWrapper>
  );
};

export default CouponValueInput;
